import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

/**
* class HSN.AlcoholModal
* Encapsulates the functionality of a modal dialog that contains rating warning.
**/
HSN.AlcoholModal = (function (_super) {
    __extends(AlcoholModal, _super);

    function AlcoholModal() {
        return AlcoholModal.__super__.constructor.call(this);
    }

    AlcoholModal.prototype._show = function (buttonClicked) {

        $.ajax(
            "/alcohol/notice?" + new Date().getTime(),
            {
                context: this,
                dataType: 'html',
                success: function (data, status, xhr) {
                    var __scope = this;
                    __scope.Root.removeClass('loading');

                    this.Content.showHtml(
                        data,
                        0,
                        function () {
                            __scope.Center();
                            __scope.Content.animate({ opacity: 1 });
                        },
                        function () {
                            //__scope.Center();
                        }
                    );

                    $('#alcohol-verification .yes').on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();

                        __scope.Root.hide();
                        $('#modal-mask').remove();

                        HSN.DataLayer.helpers.realEstate(null, 'productpage-_-age_verification-_-21');

                        sessionStorage.setItem('alcohol-verification', 'true');
                        buttonClicked.click();
                    });

                    $('#alcohol-verification .no').on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();

                        HSN.DataLayer.helpers.realEstate(null, 'productpage-_-age_verification-_-back');

                        __scope.Root.hide();
                        $('#modal-mask').remove();
                    });
                },
                error: function (xhr, status, error) {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };

    return AlcoholModal;
})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/AlcoholModal.js